import React, { Component, createRef } from 'react';
import * as Constants from '../../common/Global/constants';
import {compareObjects, getLocalStorageVariables, handleTokenExpiry, isEmptyArray, isEmptyVariable, leadingTrailingSpaceRemove} from '../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import {DialogSaveButton} from '../../common/Global/globalStyles.style';
import { DatePicker } from 'antd';
import moment from 'moment';
import AlertDialog from '../../common/AlertDialog';
import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";
let userDetails = getLocalStorageVariables();

class AddFrameworkDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            showLoader:false,

            clauseName:"",
            clauseLevel:"",
            parentClauseId:"",
            childOrder:"",
            heading:"",
            description:"",
            note:"",
            guidance:"",
            validFromDate:"",
            validToDate:"",
            formErrors:{},
            submitClickedAtleastOnce:false,
            initialValue:{},
            focusedField:""
        };
        this.frameworkNameRef = createRef();
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showCreateDialog){
            if(this.props.isEdit){
                let dropdownItem = this.props.selectedItem;
                let initialValue = {
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    frameworkClauseId:dropdownItem.frameworkClauseId,
                    frameworkId:this.props.frameworkId,
                    clauseName:dropdownItem.clauseName,
                    clauseLevel:this.props.clauseLevel,
                    parentClauseId:this.props.parentClauseId,
                    heading:dropdownItem.heading,
                    description:dropdownItem.description,
                    note:dropdownItem.note,
                    guidance:dropdownItem.guidance,
                    validFromDate: isEmptyVariable(dropdownItem.validFromDate)?"":moment(dropdownItem.validFromDate).format("YYYY-MM-DD"),
                    validToDate: isEmptyVariable(dropdownItem.validToDate)?"":moment(dropdownItem.validToDate).format("YYYY-MM-DD"),
                    createVersion:this.props.createNodeType==="createVersion"?"Y":"N",
                    childOrder:this.props.childOrder,
                    versionControl:this.props.versionControl
                }

                this.setState({
                    componentDidMountFlag:false,
                    showLoader:false,
                    frameworkClauseId:dropdownItem.frameworkClauseId,
                    frameworkName:dropdownItem.frameworkName,
                    clauseName:dropdownItem.clauseName,
                    heading:dropdownItem.heading,
                    description:dropdownItem.description,
                    note:dropdownItem.note,
                    guidance:dropdownItem.guidance,
                    validFromDate: isEmptyVariable(dropdownItem.validFromDate)?"":moment(dropdownItem.validFromDate).format("YYYY-MM-DD"),
                    validToDate: isEmptyVariable(dropdownItem.validToDate)?"":moment(dropdownItem.validToDate).format("YYYY-MM-DD"),
                    clauseLevel:this.props.clauseLevel,
                    parentClauseId:this.props.parentClauseId,
                    childOrder:this.props.childOrder,
                    versionControl:this.props.versionControl,
                    formErrors:{},
                    submitClickedAtleastOnce:false,
                    initialValue:initialValue,
                    focusedField:""
                })
            }else{
                if(this.props.createNodeType === "createVersion"){
                    let dropdownItem = this.props.selectedItem;

                    this.setState({
                        clauseName:dropdownItem.clauseName,
                        versionControl:this.props.versionControl,
                        frameworkClauseId:dropdownItem.frameworkClauseId,
                    })
                }else{
                    this.setState({
                        clauseName:""
                    })
                }
                this.setState({
                    componentDidMountFlag:false,
                    showLoader:false,
    
                    frameworkName:"",
                    heading:"",
                    description:"",
                    note:"",
                    guidance:"",
                    validFromDate:"",
                    validToDate:"",
                    clauseLevel:this.props.clauseLevel,
                    parentClauseId:this.props.parentClauseId,
                    childOrder:this.props.childOrder,
                    formErrors:{},
                    submitClickedAtleastOnce:false,
                    initialValue:{},
                    focusedField:""
                })
            }
            setTimeout(() => {
                if (this.frameworkNameRef.current) {
                    this.frameworkNameRef.current.focus();
                }
            });
        }
    }

    // handle for ReactQuill fields
    handleQuillChange = (name, value) => {
        this.setState({ [name]: value });
    }

    handleQuillFocus = (field) => {
        this.setState({ focusedField: field });
    };

    // Updates valid from date state and clears valid to date if it's before the new from date.
    onvalidFromDateChange = (date, dateString) => {
        let validFromDate = "";
		if (!isEmptyVariable(date)) {
			validFromDate = date.format("YYYY-MM-DD");
        }
        let FormErrorsTemp = this.state.formErrors;
        FormErrorsTemp['validFromDate'] = "";

        let validToDate = this.state.validToDate;
        if (validToDate && moment(validFromDate).isAfter(moment(validToDate))) {
            validToDate = "";
            FormErrorsTemp['validToDate'] = "";
        }

		this.setState({
            validFromDate:validFromDate,
            validToDate:validToDate,
            formErrors:FormErrorsTemp
        })
    }

    // Updates valid to date state.
    onValidToDateChange = (date, dateString) => {
		let validToDate = "";
		if (!isEmptyVariable(date)) {
			validToDate = date.format("YYYY-MM-DD");
        }
        let FormErrorsTemp = this.state.formErrors;
        FormErrorsTemp['validToDate'] = "";

		this.setState({
            validToDate:validToDate,
            formErrors:FormErrorsTemp
        })
    };

    // Checks if a date is in the future.
    disableFutureDates = (current) => {
        return current && current > moment().endOf('day');
    };

    // Checks if a date is before the valid from date or in the future.
    disabledToDate = (current) => {
        const { validFromDate } = this.state;
        if (this.disableFutureDates(current)) {
            return true;
          }
          return validFromDate ? current && current < moment(validFromDate, "YYYY-MM-DD") : false;
    };

    // Closes the create dialog box.
    handleCreateDialogClose = () =>{
        this.props.handleAddEditDialogClose(false);
    }

    // Handles the enter key press event, triggering the create master action.
    onEnterBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.handleCreateMaster();
        }
    }

    // Closes the alert dialog box and resets its message.
    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo: false,
            alertDialogMessageInfo: "",
        });
    };

    modules = {
		toolbar: [
			[{ header: [1, 2, 3, false] }],
			["bold", "italic", "underline", "strike", { color: [] }, { background: [] }],
			[{ list: "ordered" }, { list: "bullet" }, { align: [] }, "link"],
			["clean"],
		],
	};

    /************************API CALLS **************************/
    handleCreateMaster = () => {
        this.setState({
            showLoader:true,
            submitClickedAtleastOnce:true,
        });
        
        let isError = false;
        let FormErrorsTemp = {};

        if(isEmptyVariable(this.state.clauseName)){
            isError = true;
            FormErrorsTemp['clauseName'] = "Please enter clause name";
        }

        if(this.props.versionType === "clause" && isEmptyVariable(this.state.validFromDate)){
            isError = true;
            FormErrorsTemp['validFromDate'] = "Please select valid from date";
        }

        if(isError){
            this.setState({
                formErrors:FormErrorsTemp,
                showLoader:false
            });

        }else{
            let url = "";
            let postParam = {
                email:userDetails.email,
                accessToken:userDetails.accessToken,
            }

            if(this.props.isEdit || this.props.createNodeType === "createVersion"){
                url = Constants.UpdateFramework;
                postParam.frameworkClauseId = this.state.frameworkClauseId;
                postParam.frameworkId = this.props.frameworkId;
                postParam.clauseName = leadingTrailingSpaceRemove(this.state.clauseName);
                postParam.clauseLevel = this.state.clauseLevel;
                postParam.parentClauseId = this.state.parentClauseId;
                postParam.heading = leadingTrailingSpaceRemove(this.state.heading);
                postParam.description = leadingTrailingSpaceRemove(this.state.description);
                postParam.note = leadingTrailingSpaceRemove(this.state.note);
                postParam.guidance = leadingTrailingSpaceRemove(this.state.guidance);
                postParam.validFromDate = this.state.validFromDate;
                postParam.validToDate = this.state.validToDate;
                postParam.createVersion = this.props.createNodeType==="createVersion"?"Y":"N";
                postParam.childOrder = this.state.childOrder;
                postParam.versionControl = this.state.versionControl;
            }else{
                if(this.props.createNodeType === "child"){
                    url = Constants.AddChildFramework;
                    postParam.frameworkId = this.props.frameworkId;
                    postParam.clauseName = leadingTrailingSpaceRemove(this.state.clauseName);
                    postParam.clauseLevel = this.state.clauseLevel;
                    postParam.parentClauseId = this.state.parentClauseId;
                    postParam.heading = leadingTrailingSpaceRemove(this.state.heading);
                    postParam.description = leadingTrailingSpaceRemove(this.state.description);
                    postParam.note = leadingTrailingSpaceRemove(this.state.note);
                    postParam.guidance = leadingTrailingSpaceRemove(this.state.guidance);
                    postParam.validFromDate = this.state.validFromDate;
                    postParam.validToDate = this.state.validToDate;
                    
                }else if(this.props.createNodeType === "sibling"){
                    url = Constants.AddSiblingFramework;
                    postParam.frameworkId = this.props.frameworkId;
                    postParam.clauseName = leadingTrailingSpaceRemove(this.state.clauseName);
                    postParam.clauseLevel = this.state.clauseLevel;
                    postParam.parentClauseId = this.state.parentClauseId;
                    postParam.heading = leadingTrailingSpaceRemove(this.state.heading);
                    postParam.description = leadingTrailingSpaceRemove(this.state.description);
                    postParam.note = leadingTrailingSpaceRemove(this.state.note);
                    postParam.guidance = leadingTrailingSpaceRemove(this.state.guidance);
                    postParam.validFromDate = this.state.validFromDate;
                    postParam.validToDate = this.state.validToDate;
                    postParam.childOrder = this.state.childOrder
                
                }
            }
            const hasChanges = !compareObjects(this.state.initialValue, postParam);
            if(!hasChanges && !isEmptyArray(Object.keys(this.state.initialValue))){
                this.props.handleAddEditDialogClose()
            }else{
                fetch(url,
                {
                    method: "POST",
                    mode:'cors',
                    body: new URLSearchParams(postParam)
                })
                .then(response => { return response.json(); } )
                .then(data =>
                {
                    if(handleTokenExpiry(data.responseCode)) return;
                    else if(data.responseCode === Constants.CODE_SUCCESS){
                        this.setState({
                            showLoader:false,
                            formErrors:{},
                        },() => {
                            this.props.handleAddEditDialogClose(true);
                        });
                    }else{
                        this.setState({
                            showLoader: false,
                            showAlertDialogInfo: true,
                            alertDialogMessageInfo:data.responseMessage
                        })
                    }
                });
            }
        }
    }
    /************************API CALLS END HERE**************************/

    render() {
        return(
            <>
            <Modal className="custom-dialog" show={this.props.showCreateDialog} onHide={this.handleCreateDialogClose} backdrop="static">
                <Modal.Header>
                    <h5>{this.props.isEdit?"Edit Framework":"Add Framework"}</h5>
                    <button 
                        onClick={this.handleCreateDialogClose}
                        type="button" data-dismiss="modal">
                        <span className="material-icons">close</span>
                    </button>
                </Modal.Header>
                <hr />
                <div className="modal-body">
                    <div className="editor-card p-0">
                        <div className="task-header-layout">
                            <h6 className="editor-heading">Clause Name*</h6>
                        </div>
                        <div className={"editor-layout"}>
                            <ReactQuill
                                placeholder={"Enter Clause Name"}
                                value={this.state.clauseName} 
                                id={"clauseName"}
                                onChange={this.handleQuillChange.bind(this,"clauseName")}
                                className={this.state.focusedField === "clauseName" ? "two-lines-focus" : "two-lines"}
                                modules={this.modules}
                                onFocus={() => this.handleQuillFocus("clauseName")}
                                readOnly={this.props.createNodeType === "createVersion"}
                            />
                        </div>
                        {
                            !isEmptyVariable(this.state.formErrors['clauseName']) &&
                            <span className="cm-error">{this.state.formErrors['clauseName']}</span>
                        }
                        <div className="task-header-layout mt-3">
                            <h6 className="editor-heading">Heading</h6>
                        </div>
                        <div className={"editor-layout"}>
                            <ReactQuill
                                placeholder={"Enter Heading"}
                                value={this.state.heading}
                                id={"heading"}
                                onChange={this.handleQuillChange.bind(this,"heading")}
                                className={this.state.focusedField === "heading" ? "two-lines-focus" : "two-lines"}
                                modules={this.modules}
                                onFocus={() => this.handleQuillFocus("heading")}
                            />
                        </div>
                        <div className="task-header-layout mt-3">
                            <h6 className="editor-heading">Description</h6>
                        </div>
                        <div className={"editor-layout"}>
                            <ReactQuill
                                placeholder={"Enter Description"}
                                value={this.state.description}
                                id={"description"}
                                onChange={this.handleQuillChange.bind(this,"description")}
                                className={this.state.focusedField === "description" ? "two-lines-focus" : "two-lines"}
                                modules={this.modules}
                                onFocus={() => this.handleQuillFocus("description")}
                            />
                        </div>
                        <div className="task-header-layout mt-3">
                            <h6 className="editor-heading">Note</h6>
                        </div>
                        <div className={"editor-layout"}>
                            <ReactQuill
                                placeholder={"Enter Note"}
                                value={this.state.note}
                                id={"note"}
                                onChange={this.handleQuillChange.bind(this,"note")}
                                className={this.state.focusedField === "note" ? "two-lines-focus" : "two-lines"}
                                modules={this.modules}
                                onFocus={() => this.handleQuillFocus("note")}
                            />
                        </div>
                        <div className="task-header-layout mt-3">
                            <h6 className="editor-heading">Guidance</h6>
                        </div>
                        <div className={"editor-layout"}>
                            <ReactQuill
                                placeholder={"Enter Guidance"}
                                value={this.state.guidance}
                                id={"guidance"}
                                onChange={this.handleQuillChange.bind(this,"guidance")}
                                className={this.state.focusedField === "guidance" ? "two-lines-focus" : "two-lines"}
                                modules={this.modules}
                                onFocus={() => this.handleQuillFocus("guidance")}
                            />
                        </div>
                            {/* <div className="addnew-modal-form"> */}
                       {this.props.versionType === "clause" &&
                            <div className="row custom-row mt-3">
                                <div className="col-md-6 custom-col">
                                    <div className="addnew-modal-form-group">
                                        <p>Valid From Date*</p>
                                        <DatePicker
                                            onChange={this.onvalidFromDateChange}
                                            format={"DD/MM/YYYY"}
                                            disabledDate={this.disableFutureDates}
                                            value={!isEmptyVariable(this.state.validFromDate) ? moment(this.state.validFromDate) : ""}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['validFromDate']) &&
                                            <span className="cm-error">{this.state.formErrors['validFromDate']}</span>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6 custom-col">
                                    <div className="addnew-modal-form-group">
                                        <p>Valid To Date</p>
                                        <DatePicker
                                            onChange={this.onValidToDateChange}
                                            format={"DD/MM/YYYY"}
                                            disabledDate={this.disabledToDate}
                                            value={!isEmptyVariable(this.state.validToDate) ? moment(this.state.validToDate) : ""}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div className={`modal-close-save${this.props.versionType === "clause" ? "" : " mt-4"}`}>
                        <div className="close-save-col">
                            <button onClick={this.handleCreateDialogClose} type="button" className="modal-close">Cancel</button>
                            <DialogSaveButton 
                            themeSettings={this.props.themeSettings}
                            onClick={this.handleCreateMaster} type="button" className="modal-save">
                                {this.state.showLoader ? <div class="loader-btn mt-2"></div> : 'Save'}
                            </DialogSaveButton>
                        </div>
                    </div>
                </div>
            </Modal>
            <AlertDialog
                showAlertDialog={this.state.showAlertDialogInfo}
                handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                type={Constants.ALERT_TYPE_ALERT}
                alertDialogMessage={this.state.alertDialogMessageInfo}
                proceedBtnClick={this.handleAlertDialogCloseInfo}
                proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                themeSettings={this.props.themeSettings}
            />
            </>
        );
    }
}

export default AddFrameworkDialog;